import { ca } from '@cian/analytics';
import { ICommandPageviewData } from '@cian/analytics/dist/command';

export function trackPageview(eventData: ICommandPageviewData) {
  ca('pageviewSite', eventData);
}
